import React from 'react'

const Foreground = ({attrs = {}}) => {
	// Gestion des props manquantes avec valeurs par défaut
	const safeAttrs = {
		title: attrs?.title || 'Section foreground',
		foregroundContent: attrs?.foregroundContent || '<p>Contenu de la section foreground</p>'
	}

	return (
		<div className="block-foreground">
			<div className="block-foreground-title" dangerouslySetInnerHTML={{__html: safeAttrs.title}}/>
			<div className="block-foreground-content" dangerouslySetInnerHTML={{__html: safeAttrs.foregroundContent}}/>
		</div>
	)
}

export default Foreground
